import React from 'react';
import './style.css';

export default function Balls(): React.ReactNode {
  return (
    <div className="vipps-loader">
      <div className="vipps-ball"></div>
      <div className="vipps-ball"></div>
      <div className="vipps-ball"></div>
    </div>
  );
}
